import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Hierarchy(props: Props) {
  return (
    <div className={styles.hierarchy}>
      <Skeleton className={styles.text} />
      <span>{"<"}</span>
      <Skeleton className={styles.text} />
      <span>{"<"}</span>
      <Skeleton className={styles.text} />
    </div>
  );
}

export { Hierarchy };
